<template>
  <div class="wrap">
    <div class="header-bar">
      <router-link to="/homepage">
        <i class="fa fa-arrow-left"></i>
      </router-link>
      <!--<span>{{liveContent.about}}</span>-->
      <span>数据库发展简史</span>
    </div>
    <div class="vedio">
      <gs:video-vod id="videoComponent" site="itgege.gensee.com:80" ctx="webcast" ownerid="7f7d2649c4214249b47144d6b1c5541d"
                    uid="36931" uname="唯一弑神" authcode="444444" py="1"/>
      <!--<gs:video-vod video="" fullscreen="" site="itgege.gensee.com:80" ctx="webcast"-->
                    <!--ownerid="7f7d2649c4214249b47144d6b1c5541d"-->
                    <!--authcode="444444http://itgege.gensee.com/sdk/site/testod?ownerid=7f7d2649c4214249b47144d6b1c5541d,444444"-->
                    <!--uid="" uname="" password="" k=""py="1" bar="" logip="" logport="" logid="" compress="false"-->
                    <!--&gt;-->
        <!--<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" id="_GS_FLASH_ID__GS_WIDGET_1_1517557413324"-->
                <!--width="100%" height="100%"-->
                <!--codebase="https://fpdownload.macromedia.com/get/flashplayer/current/swflash.cab#version=10.0.12.36">-->
          <!--<param name="movie" value="http://static.gensee.com/webcast/static/sdk/flash/GenseeVod.swf?160426">-->
          <!--<param name="wmode" value="transparent">-->
          <!--<param name="quality" value="high">-->
          <!--<param name="bgcolor" value="#ffffff">-->
          <!--<param name="allowScriptAccess" value="always">-->
          <!--<param name="allowFullScreen" value="true">-->
          <!--<param name="flashvars"-->
                 <!--value="sc=2&amp;entry=http%3A%2F%2Fitgege.gensee.com%2Fwebcast&amp;code=04518a78a0916e520f94cb3a131849d06090b0e3a4aee38f46b24bdb5957c528f9b3d97aef9929a969be2aa3569b906db1c1e9cbc419f5c6&amp;lang=&amp;nickName=user_5IITMo&amp;group=&amp;isLoop=false&amp;widgetid=_GS_WIDGET_1_1517557413324&amp;py=1&amp;lang=&amp;showCBar=&amp;backURI=&amp;hlsMode=false&amp;fullscreen=false">-->
          <!--<embed src="http://static.gensee.com/webcast/static/sdk/flash/GenseeVod.swf?160426" quality="high"-->
                 <!--bgcolor="#ffffff" wmode="transparent" width="100%" height="100%"-->
                 <!--name="_GS_FLASH_ID__GS_WIDGET_1_1517557413324" align="middle" play="true" loop="false"-->
                 <!--allowscriptaccess="always" allowfullscreen="true" type="application/x-shockwave-flash"-->
                 <!--flashvars="sc=2&amp;entry=http%3A%2F%2Fitgege.gensee.com%2Fwebcast&amp;code=04518a78a0916e520f94cb3a131849d06090b0e3a4aee38f46b24bdb5957c528f9b3d97aef9929a969be2aa3569b906db1c1e9cbc419f5c6&amp;lang=&amp;nickName=user_5IITMo&amp;group=&amp;isLoop=false&amp;widgetid=_GS_WIDGET_1_1517557413324&amp;py=1&amp;lang=&amp;showCBar=&amp;backURI=&amp;hlsMode=false&amp;fullscreen=false"-->
                 <!--pluginspage="http://www.adobe.com/go/getflashplayer">-->
        <!--</object>-->
      </gs:video-vod>
    </div>
    <div class="play-desc">
      <ul>
        <li :class="{'changeblue' : checknow === 1}" @click="toggleInfo">简介</li>
        <li :class="{'changeblue' : checknow === 2}" @click="togglePpt">PPT</li>
        <li :class="{'changeblue' : checknow === 3}" @click="toggleChet">聊天</li>
      </ul>
    </div>
    <div class="content">
      <div class="show-info" v-show="isInfoShow">
        <div class="titlecontent">
          <div class="titleact">
            <!--<p class="maintitle">{{liveContent.about}}</p>-->
            <!--<p style="color: #656b79;margin: 0.2rem">时间：{{liveContent.liveTime}}</p>-->
            <p class="maintitle">数据库发展简史</p>
            <p style="color: #656b79;margin: 0.2rem">时间：20170108</p>
          </div>
          <!--<div class="livetype">-->
            <!--{{liveContent.status}}-->
          <!--</div>-->
          <div class="livetype">
            正在直播
          </div>
        </div>
        <div class="liveintroduction">
          <div style="display: flex;align-items: center;margin-top: 2px">
            <div style="background: #ff0033;width: 3px;height: 9px;margin:6px"></div>
            <p style="font-size: 17px;color: #666666">活动简介</p>
          </div>
          <div style="margin-top: 0.2rem">
            <p v-bind:class="{ active: isActive }">
              鬼门现，诞生在这一天的我，被视为不祥，
              母因我而死，父惧弃，我还来不及好好感受这个世界的温暖，
              就被无情的抛弃，险境横生，阴邪大黑蛇将我卷入一古老的地洞中，
              未曾想这竟是一个千年古墓，我的到来，似乎唤醒了沉睡了上千年的灵魂
              ，至此，我竟被一个神秘的千年美男父亲养育成人。 长大后，外出历练
              ，发现外面的世界太精彩，想要成龙的大蛟龙，深海的美人鱼，各种奇形
              怪状的恶鬼凶灵，好刺激，好危险。 逆天神魔体，阴阳眼，收灵宠，降神
              兽，我不得已与药神融为一体，在不平凡的道路上越走越远，直到看不见
              尽头。 什么？你问谁最宠我？这个我得想想......</p>
            <div @click="introtoggle" style="text-align: center">
              <img style="margin: 0.3rem;" :src="toggleupordown" width="15px" height="15px">
            </div>
          </div>
        </div>
        <div class="teacher">
          <div style="display: flex;align-items: center;margin-top: 2px">
            <div style="background: #ff0033;width: 3px;height: 9px;margin:6px"></div>
            <p style="font-size: 17px;color: #666666">嘉宾简介</p>
          </div>
          <ul style="list-style: none">
            <li>
              <div class="teachercontent">
                <div class="teacherimg">
                  <img src="./../../assets/img/meeting.png" alt="">
                </div>
                <div class="teacherindoc">
                  <p>宗福季</p>
                  <p>香港科技大学工业设计与物流管理教授</p>
                </div>
                <div class="toggledown" @click="teachertoggleAA">
                  <img src="./../../../static/todown.png" alt="">
                </div>
              </div>
              <div style="width: 100%;position: relative" v-show="teachertoggleA">
                <p> 鬼门现，诞生在这一天的我，被视为不祥，
                  母因我而死，父惧弃，我还来不及好好感受这个世界的温暖，
                  就被无情的抛弃，险境横生，阴邪大黑蛇将我卷入一古老的地洞中，
                  未曾想这竟是一个千年古墓，我的到来，似乎唤醒了沉睡了上千年的灵魂</p>
              </div>
            </li>
            <li>
              <div class="teachercontent">
                <div class="teacherimg">
                  <img src="./../../assets/img/meeting.png" alt="">
                </div>
                <div class="teacherindoc">
                  <p>宗福季</p>
                  <p>香港科技大学工业物流管理教授</p>
                </div>
                <div class="toggledown"  @click="teachertoggleBB">
                  <img src="./../../../static/todown.png" alt="">
                </div>
              </div>
              <div style="width: 100%;position: relative" v-show="teachertoggleB">
                <p> 鬼门现，诞生在这一天的我，被视为不祥，
                  母因我而死，父惧弃，我还来不及好好感受这个世界的温暖，
                  就被无情的抛弃，险境横生，阴邪大黑蛇将我卷入一古老的地洞中，
                  未曾想这竟是一个千年古墓，我的到来，似乎唤醒了沉睡了上千年的灵魂</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="youlike">
          <div style="display: flex;align-items: center;margin-top: 2px">
            <div style="background: #ff0033;width: 3px;height: 9px;margin: 8px"></div>
            <p style="font-size: 17px;color: #666666">猜你喜欢</p>
          </div>
          <scroll-bar url="mobile/video/?" :tech="!abc"></scroll-bar>
        </div>
      </div>
      <div class="show-Ppt" v-show="isPptShow">
        <!--<gs:doc site="itgege.gensee.com:80" ctx="webcast" group="primary" ownerid="7f7d2649c4214249b47144d6b1c5541d"-->
                <!--authcode="444444http://itgege.gensee.com/sdk/site/testod?ownerid=7f7d2649c4214249b47144d6b1c5541d,444444"-->
                <!--uid="" uname="" compress="false" >-->
          <!--<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" id="_GS_FLASH_ID__GS_WIDGET_2_1517557413326"-->
                  <!--width="100%" height="100%"-->
                  <!--codebase="https://fpdownload.macromedia.com/get/flashplayer/current/swflash.cab#version=10.1.0.0">-->
            <!--<param name="movie" value="http://static.gensee.com/webcast/static/sdk/flash/GenseePD.swf?160426">-->
            <!--<param name="wmode" value="transparent">-->
            <!--<param name="quality" value="high">-->
            <!--<param name="bgcolor" value="#ffffff">-->
            <!--<param name="allowScriptAccess" value="always">-->
            <!--<param name="allowFullScreen" value="true">-->
            <!--<param name="flashvars"-->
                   <!--value="code=7f7d2649c4214249b47144d6b1c5541d&amp;group=&amp;widgetid=_GS_WIDGET_2_1517557413326&amp;isSupportFull=false&amp;backgroundColor=&amp;trans=&amp;icon=true&amp;backURI=">-->
            <!--<embed src="http://static.gensee.com/webcast/static/sdk/flash/GenseePD.swf?160426" quality="high"-->
                   <!--bgcolor="#ffffff" wmode="transparent" width="100%" height="100%"-->
                   <!--name="_GS_FLASH_ID__GS_WIDGET_2_1517557413326" align="middle" play="true" loop="false"-->
                   <!--allowscriptaccess="always" allowfullscreen="true" type="application/x-shockwave-flash"-->
                   <!--flashvars="code=7f7d2649c4214249b47144d6b1c5541d&amp;group=&amp;widgetid=_GS_WIDGET_2_1517557413326&amp;isSupportFull=false&amp;backgroundColor=&amp;trans=&amp;icon=true&amp;backURI="-->
                   <!--pluginspage="http://www.adobe.com/go/getflashplayer">-->
          <!--</object>-->
        <!--</gs:doc>-->
        <!--<gs:doc id="docComponent"  ctx="webcast"  site="itgege.gensee.com" ownerid="7f7d2649c4214249b47144d6b1c5541d" />-->
        <gs:doc id="docComponent" site="itgege.gensee.com:80" ctx="webcast"
                ownerid="7f7d2649c4214249b47144d6b1c5541d"
                authcode="444444http://itgege.gensee.com/sdk/site/testod?ownerid=7f7d2649c4214249b47144d6b1c5541d,444444"
                uid="" uname="" compress="false"/>
      </div>
      <div class="toggleChet" v-show="isChetShow">
        <ul class="cmt-list">
          <li v-for="(cmt, index) in comment">
            <img :src="cmt.member.avatar" alt="" class="avatar">
            <span class="name">{{cmt.member.uname}}</span>
            <p class="comment-msg">{{cmt.content.message}}</p>
          </li>
        </ul>
        <div class="talk">
          <img src="./../../assets/img/emoji.png" alt="" class="emoji">
          <input type="text" v-model="cmtContent" @keypress.enter="submitCmt" placeholder="说点什么把">
          <img src="./../../assets/img/send.png" alt="" class="send" @click="submitCmt">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isActive: true,
        isInfoShow: true,
        isPptShow: false,
        isChetShow: false,
        toggleupordown: '../../static/todown.png',
        abc: true,
        testList: 'asd',
        courseId: '',
        liveContent: '',
        comment: [],
        cmtContent: '',
        checknow: 1,
        teachertoggleA: false,
        teachertoggleB: false
      }
    },
    beforeCreate(){
      this.$store.state.mttabbarshow = false
    },
    created () {
      // this.courseId = this.$route.query.liveid
      // let that = this
      // this.axios.get('').then(res => {
      //   that.testList = res.data.data
      //   that.liveContent = res.data.data
      // })
    },
    destroyed () {
      this.$store.state.mttabbarshow = true
    },
    mounted () {
      const livepagereload1 = this.$store.state.livepagereload
      console.log('aaa')
    
    },
    methods: {
      toggleInfo () {
        this.isInfoShow = true
        this.isPptShow = false
        this.isChetShow = false
        this.abc = true
        this.checknow = 1
      },
      togglePpt () {
        this.isInfoShow = false
        this.isPptShow = true
        this.isChetShow = false
        this.abc = false
        this.checknow = 2
      },
      toggleChet () {
        this.isInfoShow = false
        this.isPptShow = false
        this.isChetShow = true
        this.abc = false
        this.checknow = 3
      },
      introtoggle () {
        this.isActive = !this.isActive
        if (this.toggleupordown == '../../static/todown.png') {
          this.toggleupordown = '../../static/toup.png'
        } else {
          this.toggleupordown = '../../static/todown.png'
          console.log(this.toggleupordown)
          console.log(this.isActive)
          console.log(this.text)
        }
      },
      teachertoggleAA () {
        this.teachertoggleA = !this.teachertoggleA
      },
      teachertoggleBB () {
        this.teachertoggleB = !this.teachertoggleB
      },
      submitCmt () {
        let content = this.cmtContent
        if (content === '') {
          this.util.cmtPop()
        } else {
          this.comment.unshift({
            member: {
              uname: "逍遥散人",
              avatar: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1517827985753&di=3913b4c19a4e188b36f9324bd987e539&imgtype=0&src=http%3A%2F%2Fww1.sinaimg.cn%2Fcrop.0.0.500.500.1024%2F0067xuV2jw8es50wl5kmcj30dw0dwdg2.jpg"
            },
            content: {
              message: content
            }
          })
        }
        this.cmtContent = ''
      }
    }
  }
</script>

<style lang="less" scoped>
  @import './../../assets/css/LivePage.less';

  .active {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .changeblue {

    color: #3e92cb;
  }
</style>



// WEBPACK FOOTER //
// src/components/Live-Chileren/LivePage.vue